<script>
    import NotificationModal from "./NotificationModal.svelte";
    import {
        showConfirmActionModal,
        confirmActionModalDetails,
    } from "../../stores";
    import { showError } from "../../Utils/utilFunctions.svelte";

    const resetDetails = () => {
        confirmActionModalDetails.set({
            title: "Confirmation",
            message: "",
            actions: [],
            modalMaxWidth: "",
        });
    };

    const closeModal = () => {
        showConfirmActionModal.set(false);
        resetDetails();
    };

    const handleActionClick = async (action) => {
        if (!action || typeof action.onClick !== "function") {
            closeModal();
            return;
        }

        await Promise.resolve(action.onClick())
            .then(() => closeModal())
            .catch(showError);
    };

    $: modalTitle = $confirmActionModalDetails.title || "Confirmation";
    $: modalMessage = $confirmActionModalDetails.message || "";
    $: modalActions = Array.isArray($confirmActionModalDetails.actions)
        ? $confirmActionModalDetails.actions
        : [];
    $: modalMaxWidth = $confirmActionModalDetails.modalMaxWidth || "";
</script>

<NotificationModal
    isModalOpen={$showConfirmActionModal}
    title={modalTitle}
    showConfirmBtn={false}
    closeModal={closeModal}
    closeModalFunction={closeModal}
    contentClass="p-6 flex flex-col gap-y-4"
    modalMaxWidth={modalMaxWidth}
    btnOptions={modalActions.map((action) => ({
        text: action.title,
        isDisabled: action.isDisabled,
        class: action.class,
        function: () => handleActionClick(action),
    }))}
>
    <p>{modalMessage}</p>
</NotificationModal>
